<template>
    <div>
        <!--edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">{{ ProdutosConsulta.cpcId ? 'Alterar produto de consulta' : 'Novo produto de consulta' }}</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Cadastro de produtos consulta</a> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><span>{{ ProdutosConsulta.cpcId ? 'Alterar' : 'Novo cadastro' }}</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="gp-admin-form-header">
                                <span><v-icon size="20">mdi-package-variant-closed</v-icon></span>
                                <div>
                                    <h4>{{ ProdutosConsulta.cpcId ? 'Alterar produto de consulta' : 'Novo produto de consulta' }}</h4>
                                    <p>Preencha os dados e defina a disponibilidade deste cadastro.</p>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-lg-2" v-show="false">
                                        <div class="form-group">
                                            <label>Identificador</label>
                                            <input v-model="ProdutosConsulta.cpcId" type="text" class="form-control"
                                                placeholder="Id" />
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label>Nome Produto</label>
                                            <input v-model="ProdutosConsulta.cpcNomeProduto"
                                                type="text" class="form-control" placeholder="Nome Produto" />
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Código DeltaPag</label>
                                            <input v-model="ProdutosConsulta.cpcCodProdutoDelta"
                                            type="number" class="form-control" placeholder="Cod. Delta" />
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Ativo</label>
                                            <select v-model="ProdutosConsulta.cpcAtivo" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-admin-actions gp-detail-actions">
                        <button v-if="ProdutosConsulta.cpcId != 0" type="button" class="btn btn-success"
                            style="color:#ffffff;" @click="Put()">
                            Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            Salvar
                        </button>
                        <a href="#" @click="EditCancel()" class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de produtos consulta</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body">
                                <adm-data-table :headers="headers" :items="ProdutosConsultas" v-model="itemsSelected" alternating
                                    theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina">
                                    <template #item-cpcAtivo="item">
                                        <span>{{ item.cpcAtivo ? 'Sim' : 'Não' }}</span>
                                    </template>
<template #item-actions="item">
    <div class="gp-table-actions">
        <button type="button" class="gp-table-action gp-action-edit" title="Editar" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
        <button v-show="false" type="button" class="gp-table-action gp-action-delete" title="Excluir" @click="DeleteGrid(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
    </div>
</template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'CadastroProdutosConsultaView',
    components: {
        EasyDataTable
    },
    data: () => ({
        EditView: false,
        ProdutosConsulta: {
            cpcId: 0,
            cpcNomeProduto: '',
            cpcCodProdutoDelta: '',
            cpcAtivo: '',
        },
        ProdutosConsultas: [],
        selectedVisivel: null,
        headers: [
            { text: "Id", value: "cpcId", sortable: true, },
            { text: "Nome", value: "cpcNomeProduto", sortable: true, },
            { text: "Cod. DeltaPag", value: "cpcCodProdutoDelta", sortable: true, },
            { text: "Ativo", value: "cpcAtivo", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
    }),
    methods: {
          //edit
          EditNew(){
            this.EditView = true;
            this.ProdutosConsulta.cpcId = 0;
            this.ProdutosConsulta.cpcNomeProduto= '';
            this.ProdutosConsulta.cpcCodProdutoDelta= '';
            this.ProdutosConsulta.cpcAtivo= '';
        },
        EditGrid(item) {
            this.EditView = true;
            if (item.cpcId != ''){
            axios.get(`/Telas/ProdutosConsulta/GetById/` + item.cpcId)
                .then(response => {
                    this.ProdutosConsulta = response.data;
                });
            }
        },
        EditCancel(){
            //window.location.reload();
            this.$router.go(0);
        },
        Add() {
            if (this.ProdutosConsulta.cpcNomeProduto == '') {
                this.$mensagemAviso("Nome Produto Obrigatório.")
            }
            else if (this.ProdutosConsulta.cpcCodProdutoDelta === '') {
                this.$mensagemAviso("Cod. Delta Obrigatório.")
            }
            else if (this.ProdutosConsulta.cpcAtivo === '') {
                this.$mensagemAviso("Ativo Obrigatório.")
            }
            else {
                axios.post(`/Telas/ProdutosConsulta/Add`, this.ProdutosConsulta)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                        }
                    });
            }
        },
        Put() {
            if (this.ProdutosConsulta.cpcNomeProduto == '') {
                this.$mensagemAviso("Nome Produto Obrigatório.")
            }
            else if (this.ProdutosConsulta.cpcCodProdutoDelta === '') {
                this.$mensagemAviso("Cod. Delta Obrigatório.")
            }
            else if (this.ProdutosConsulta.cpcAtivo === '') {
                this.$mensagemAviso("Ativo Obrigatório.")
            }
            else {
                axios.put(`/Telas/ProdutosConsulta/Update`, this.ProdutosConsulta)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                        }
                    });
            }
        },
        //edit
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.cpcId;
                axios.delete(`/Telas/ProdutosConsulta/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                    }
                });
            }
            });
        },
        Get() {
            this.EditView = false;
            axios.get(`/Telas/ProdutosConsulta/GetAll`)
                .then(response => {
                    this.ProdutosConsultas = response.data;
                });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
